// extracted by mini-css-extract-plugin
module.exports = {"container":"liked_container__DDzAL","title":"liked_title__7_7g9"};